import React, { useState } from 'react';
import * as bd from 'react-basic-design';
import { T } from '../basic/text';
import { SelectUserModal } from './select-user-modal';
import SvgAdd from '../../assets/icons/Add';

export const SelectUser = ({
    onChange,
}: {
    onChange: ({ userName, displayName }: { userName: string; displayName: string }) => void;
}) => {
    const [show, setShow] = useState<boolean>(false);

    return (
        <bd.Flex align="center">
            <bd.Flex align="center" content="start">
                <bd.Button variant="outline" size="sm" onClick={() => setShow(true)}>
                    <SvgAdd />
                    <T>new-user</T>
                </bd.Button>
            </bd.Flex>
            <SelectUserModal show={show} onHide={() => setShow(false)} onChange={onChange} />
        </bd.Flex>
    );
};
